<template>
  <div>
    <div
      class="period-header"
      :class="{
        'period-header-7': type == 7,
        disabled: !$services.CourseService.checkLiveState(type, period),
      }"
      @click="targetPeriod(period)"
    >
      <div
        class="period-title"
        :class="{ 'period-title-10': type == 10 }"
        :title="period.periods_title"
      >
        <span
          class="period-point"
          :class="{ 'period-point-try': period.is_try_see }"
        ></span>
        <span class="period-try" v-if="period.is_try_see">{{ tryText }}</span>
        <span class="period-title-content">{{ period.periods_title }}</span>
      </div>
    </div>
    <div class="period-info" v-if="type != 5 && type != 8 && type != 10">
      <div class="period-teacher">
        <span class="period-teacher-name" :title="period.teacher_name">
          讲师：{{ period.teacher_name }}
        </span>
        <template v-if="period.start_play">
          <span class="line">|</span>
          <span>{{ period.start_play + " ~ " + period.end_play }}</span>
        </template>
      </div>
      <div
        class="period-playback"
        v-if="
          type == 16 && (period.play_type == 4 || period.min_play_type == 4)
        "
      >
        <a
          class="btn-blank"
          @click.stop="targetPeriod(period, 1)"
          v-if="period.play_type == 4"
        >
          查看大教室回放
        </a>
        <a
          class="btn-blank"
          @click.stop="targetPeriod(period, 2)"
          v-if="period.min_play_type == 4"
        >
          查看小教室回放
        </a>
      </div>
      <div
        class="period-state"
        :class="'period-state' + period.play_type.toString()"
        v-if="type != 5 && type != 8 && type != 10"
      >
        <template v-if="type == 2 || type == 15 || type == 3 || type == 16">
          <template v-if="period.play_type == 1">
            <img src="@/assets/images/course/period-notbegin@2x.png" />
            <span>未开始</span>
          </template>
          <template v-else-if="period.play_type == 2">
            <img src="@/assets/images/course/period-progress@2x.png" />
            <span>直播中</span>
          </template>
          <template v-else>
            <img src="@/assets/images/course/period-end@2x.png" />
            <span>已结束</span>
          </template>
          <!-- <template v-else-if="period.play_type == 3">查看回放</template>
          <template v-else-if="period.play_type == 4||period.play_type == 5">查看回放</template>-->
        </template>
        <template v-else-if="type == 7">
          <template v-if="period.play_type == 1">未开始</template>
          <template v-else-if="period.play_type == 2">开课中</template>
          <template v-else-if="period.play_type == 3">已结束</template>
        </template>
      </div>
    </div>
    <div class="period-files" v-if="period.files.length">
      <div
        v-for="(file, index) in period.files"
        class="period-file-wrap"
        :key="file.file_url"
        :title="file.file_name"
      >
        <div class="period-file clearfix">
          <img src="@/assets/images/course/file@3x.png" class="file-type" />
          <a
            href="javascript:void(0)"
            @click="visitFile(file.datum_id, index + 1)"
          >
            {{ file.file_name }}
          </a>
        </div>
      </div>
    </div>
    <el-dialog
      title="查看课时内容"
      :visible.sync="showContentDialog"
      :center="true"
      width="700px"
    >
      <div
        v-html="chapter_content"
        class="rich-auto"
        @contextmenu="
          $event => {
            $event.preventDefault();
          }
        "
      ></div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="showContentDialog = false">
          确定
        </el-button>
      </div>
    </el-dialog>
    <CourseSoldOutTip :show.sync="showSoldOut"></CourseSoldOutTip>
  </div>
</template>
<script>
import CourseSoldOutTip from "@/modules/stu/components/CourseSoldOutTip.vue";
export default {
  name: "CoursePeriod",
  components: { CourseSoldOutTip },
  props: {
    period: {
      type: Object,
    },
    course: {
      type: Object,
    },
    tryText: {
      type: String,
      default: "试看",
    },
  },
  data() {
    return {
      parent: this.$route.query.parent,
      type: 0,
      showContentDialog: false,
      chapter_content: "",
      showSoldOut: false,
    };
  },
  created() {
    this.type = this.course.course_type;
  },
  methods: {
    async visitFile(id, index) {
      if (this.course.is_buy == 0) {
        return this.$info("请您先报名");
      }
      await this.$services.CourseService.openPeriodFile(
        this.period,
        id,
        index,
        this.parent,
      );
    },
    async targetPeriod(period, type) {
      if (
        !this.$services.CourseService.checkLiveState(
          this.course.course_type,
          period,
        )
      ) {
        return;
      }
      if (this.course.is_buy == 0 && period.is_try_see == 0) {
        return this.$info("请您先报名");
      }
      if (this.course.is_buy == 1) {
        await this.$services.CourseService.checkLimit(this.course.id);
        if (!this.$services.CourseService.checkBuyValid(this.course)) {
          return this.$info("该课程已过期，无法继续学习");
        }
      }
      if (this.type == 10) {
        let data = await this.$services.CourseService.getPeriodContent(
          period,
          this.parent,
        );
        this.chapter_content = data.course_content;
        this.showContentDialog = true;
      } else {
        if (this.type == 16) {
          if (
            this.course.is_buy == 0 &&
            (period.play_type == 1 || period.play_type == 2)
          ) {
            if (period.min_class == 0) {
              this.$info("现在还不能观看哦，待会再来吧~");
              return;
            }
            type = 2;
          }
          if (!type) {
            type = 2;
          }
        } else if (!type) {
          type = 1;
        }

        console.log("此处已埋雷");
        await this.$http.get(`/api/app/study/click/${period.period_id}`);
        await this.$services.CourseService.watchVideo(
          period,
          this.course.course_type,
          this.course.id,
          type,
        );
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.period-header {
  display: flex;
  align-items: center;
}

.period-header:not(.period-header-7) {
  cursor: pointer;

  &:hover {
    .period-title-content {
      color: $primary-color;
    }
  }

  &.disabled {
    cursor: default;
  }
}

.period-title {
  font-size: 16px;
  color: #595959;
  overflow: hidden;
  display: flex;
  align-items: center;
  flex-grow: 1;

  .period-title-content {
    height: 20px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(89, 89, 89, 1);
    line-height: 20px;
    flex-grow: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &.period-title-10 {
    width: auto;
  }
}

.period-try {
  font-size: 12px;
  color: white;
  display: inline-block;
  width: 44px;
  height: 17px;
  line-height: 17px;
  text-align: center;
  background-image: url("~@/assets/images/course/try-back@2x.png");
  background-size: 100% 100%;
  margin-right: 8px;
}

.period-point {
  width: 5px;
  height: 5px;
  background-color: $primary-color;
  border-radius: 100%;
  display: inline-block;
  margin-right: 18px;
  flex-shrink: 0;

  &.period-point-try {
    margin-right: 8px;
  }
}

.period-files {
  padding-top: 12px;
}

.period-file-wrap {
  margin-bottom: 15px;
  height: 32px;

  &:last-child {
    margin-bottom: 0;
  }

  .period-file {
    background: $primary-color-light;
    border-radius: 16px;
    padding: 0 12px;
    height: 32px;
    box-sizing: border-box;
    display: flex;
    align-items: center;

    .file-type {
      width: 9px;
      margin-right: 6px;
      float: left;
    }

    a {
      height: 20px;
      line-height: 20px;
      font-size: 14px;
      color: $primary-color;
      float: right;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}

.period-info {
  display: flex;
  align-items: center;
  height: 32px;
  margin-top: 9px;
}

.period-teacher {
  font-size: 16px;
  color: #666666;
  flex: 1;
  display: flex;
  white-space: nowrap;
  overflow: hidden;
  margin-right: 10px;

  .line {
    color: #cccccc;
    margin: 0 10px;
  }
}

.period-teacher-name {
  overflow: hidden;
  text-overflow: ellipsis;
}

.period-playback {
  margin-right: 14px;
  a {
    display: inline-block;
    width: 132px;
    height: 32px;
    border-radius: 16px;
    font-size: 14px;
    line-height: 30px;
    text-align: center;
    margin-right: 10px;
  }
}

.period-state {
  font-size: 14px;
  display: flex;
  align-items: center;
  white-space: nowrap;

  img {
    width: 14px;
    margin-right: 6px;
  }

  &.period-state2 {
    color: $primary-color;
  }

  &.period-state1,
  &.period-state3,
  &.period-state4,
  &.period-state5 {
    color: #999999;
  }
}
</style>
